<script>
import options from './ConfirmDeleteProfile.options'
export default options
</script>

<template>
  <article class="kb-confirm-changes">
    <section class="kb-confirm-changes__hero">
      <div class="kb-confirm-changes__hero__title-wrapper">
        <h2 class="kb-confirm-changes__hero__title-wrapper__title">
          {{ getLabel('title') }}
        </h2>
      </div>
    </section>
    <div class="kb-confirm-changes__hero__curve">
      <svg role="presentation" viewBox="0 0 720 77" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 0V42.4078C238.547 71.2459 479.584 82.0555 720 74.8278V0H0Z" />
      </svg>
    </div>

    <div class="kb-confirm-changes__content-container">
      <p>{{
            getLabel('text')
          }}</p>
      <div class="kb-confirm-changes__button-wrapper">
        <button @click="confirmAction" @keydown.tab="tabTrap" data-order="first"
          class="kb-button kb-button--full-color-spot kb-confirm-changes__kb-button--full-color-spot">{{
            getLabel('confirmButton')
          }}</button>
        <button @click="cancelAction" data-order="last" @keydown.tab="tabTrap" class="kb-button">{{
            getLabel('cancelButton')
          }}</button>
      </div>
    </div>
  </article>
</template>
